import { defineMessages } from '@/i18n';

export const dashboardMessages = defineMessages({
  pageTitle: 'platform.app.invitations.welcome',
  noStoreFronts: 'platform.app.dashboard.empytState.title',
  noInventory: 'platform.app.dashboard.empytState.recently-update-items.title',
  createStoreFrontsText: 'platform.app.dashboard.empytState.subtitle',
  joinStoreFronts: 'platform.app.dashboard.empytState.button.join',
  createStoreFronts: 'platform.app.dashboard.empytState.button.create',
  failedToastTitleForStoreFronts: 'platform.app.dashboard.failed.failedToastTitleForStoreFronts',
  verifyPaymentAccount: 'platform.app.gallery.paymentStatusBanner.verifyAccount',
  recentlyUpdateItemsUploadButton: 'platform.app.dashboard.empytState.recently-update-items.upload',
  recentlyUpdateItemsNewItemButton: 'platform.app.dashboard.empytState.recently-update-items.new-item',
  recentlyUpdateItemsTitle: 'platform.app.dashboard.recently-update-items.title',
  recentlyUpdateItemsMyItemsButton: 'platform.app.dashboard.recently-update-items.button.my-items',
  recentlyUpdateItemNewItemsButton: 'platform.app.dashboard.recently-update-items.button.new-item',
  noPendingActions: 'platform.app.dashboard.notifications.emptyState.subtitle',
  notificationTitle: 'platform.app.dashboard.notifications.title',
  statusSigned: 'platform.app.dashboard.notifications.status.signed',
  statusPending: 'platform.app.dashboard.notifications.status.pending',
  status: 'platform.app.dashboard.notifications.status',
  storefrontsHeader: 'platform.app.dashboard.storeFronts.header',
  storefrontsHeaderArtBasel: 'platform.app.dashboard.storeFronts.headerArtBasel',
  storefrontsAndViewingRoomHeader: 'platform.app.dashboard.storefrontsAndViewingRoomHeader.header',
  storeFrontsListedItems: 'platform.app.dashboard.storeFrontsListedItems',
  storeFrontsViewingRooms: 'platform.app.dashboard.storeFrontsViewingRooms',
  storeFrontsViewingRoomsArtBasel: 'platform.app.dashboard.storeFrontsViewingRoomsArtBasel',
  newViewingRoomButton: 'platform.app.dashboard.newViewingRoomButton',
  newViewingRoomButtonArtBasel: 'platform.app.dashboard.newViewingRoomButtonArtBasel',
  published: 'platform.app.dashboard.published',
  unpublished: 'platform.app.dashboard.unpublished',
  public: 'platform.app.dashboard.public',
  private: 'platform.app.dashboard.private',
  publicStorefront: 'platform.app.dashboard.publicStorefront',
  publicStorefrontArtBasel: 'platform.app.dashboard.publicStorefrontArtBasel',
});
